<template>
  <v-card outlined>
    <v-card-text>
      <h2 v-if="!orders.length">You haven't placed any orders yet!</h2>
      <v-data-table
        class="orders-table"
        v-else
        :headers="headers"
        :items="orderModels"
        :items-per-page="15"
        sort-by="created_at"
        sort-desc
        @click:row="handleRowClick"
      >
        <template #item.paid="{item}">
          <v-icon dense :color="item.paid ? 'green' : 'grey lighten-2'"
            >mdi-currency-usd</v-icon
          >
        </template>
        <template #item.completed="{item}">
          <v-simple-checkbox
            v-model="item.completed"
            class="center-checkbox"
            disabled
            dense
          />
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { CustomerRoutes } from '@/constants/RouteNames'
import OrderModel from '@/models/OrderModel'

export default {
  name: 'CustomerOrders',
  props: {
    orders: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    orderModels() {
      return OrderModel.query()
        .whereIdIn(this.orders.map((i) => i.id))
        .all()
    }, // orderModels
  },
  data() {
    return {
      OrderModel,
      headers: [
        { text: 'Time Ordered', value: 'time_ordered', sortable: false },
        { text: 'Paid', value: 'paid', sortable: false },
        {
          text: 'Completed',
          value: 'completed',
          sortable: false,
          align: 'center',
        },
        { text: 'Total', value: 'grand_total_formatted', sortable: false },
        {
          text: 'Fulfillment Slot',
          value: 'fulfillment_slot',
          sortable: false,
        },
      ],
    }
  },
  methods: {
    handleRowClick(item) {
      this.$router.push({
        name: CustomerRoutes.ORDER_VIEW,
        params: { ...this.$route.params, orderId: item.id },
      })
    }, // handleRowClick
  },
}
</script>
<style>
.orders-table table tbody tr {
  cursor: pointer;
}
.orders-table .v-simple-checkbox--disabled {
  cursor: pointer;
}
</style>
